import { onMounted, onUnmounted } from "vue";
import {
  useGrimoireStore,
  usePlayersStore,
  useSessionStore,
  useSoundboardStore,
  useUserPreferencesStore,
  useVotingStore,
} from "@/stores";

export function useKeyboardShortcuts() {
  const grimoire = useGrimoireStore();
  const playersStore = usePlayersStore();
  const session = useSessionStore();
  const soundboard = useSoundboardStore();
  const userPreferences = useUserPreferencesStore();
  const votingStore = useVotingStore();

  const keyHandlers = new Map<string, () => void>([
    ["g", () => { userPreferences.hideGrim = !userPreferences.hideGrim; }],
    ["a", () => playersStore.addPlayer()],
    ["p", () => playersStore.addPlayers()],
    ["h", () => {
      if (!session.isPlayerOrSpectator && session.sessionId) {
        soundboard.playSound({ sound: "gavel" });
      } else {
        session.hostSession();
      }
    }],
    ["j", () => session.joinSession()],
    ["r", () => grimoire.toggleModal("reference")],
    ["n", () => grimoire.toggleModal("nightOrder")],
    ["e", () => !session.isPlayerOrSpectator && grimoire.toggleModal("edition")],
    ["c", () => !session.isPlayerOrSpectator && grimoire.toggleModal("roles")],
    ["v", () => {
      if (votingStore.voteHistory.length || !session.isPlayerOrSpectator) {
        grimoire.toggleModal("voteHistory");
      }
    }],
    ["s", () => session.isPlayerOrSpectator ? playersStore.toggleRaisedHandAt() : grimoire.toggleNight()],
    ["b", () => !session.isPlayerOrSpectator && soundboard.playSound({ sound: "ringing" })],
    ["d", () => !session.isPlayerOrSpectator && soundboard.playSound({ sound: "rooster" })],
    ["escape", () => grimoire.toggleModal(null)],
    ["q", () => { userPreferences.notes.opened = !userPreferences.notes.opened; }],
  ]);

  function keyup(event: KeyboardEvent) {
    const { key, ctrlKey, metaKey } = event;
    const target = event.target as HTMLElement;
    if (ctrlKey || metaKey || ["INPUT", "TEXTAREA"].includes(target.tagName) || target.isContentEditable) return;

    const handler = keyHandlers.get(key.toLocaleLowerCase());
    if (handler) {
      event.preventDefault();
      handler();
    }
  }

  onMounted(() => {
    window.addEventListener("keyup", keyup);
  });

  onUnmounted(() => {
    window.removeEventListener("keyup", keyup);
  });
}
